import { authApiService } from '../../authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const sendForgotPasswordTwoFACodeApi = async (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/users/forgot-password/2fa/send-code/`;

  return authApiService.POST(uri, {});
};
